export const colors = {
  LandingPage_Background: "#FFFFFF",
  LandingPage_Description: "#373737",
  Button_Primary: "#46F34D",
  yeIl: "#fff",
  CardB: "#212121",
  Button_Secondary: "#D1A219",
  Header_Background: "#FFFFFF",
  Header_Content: "#000000",
  Black: "#000000",
  test: "#bbb",
  Header: "#383C3D",
  whitebg: "#fff",
  Header_Text: "#FFFFFF",
  Header_Text_back: "#4C5152",
  Table_Header: "#BFCACD",
  Action_Button_Back: "#0A6AAD",
  ALERT_BUTTON_GOTO_COLOR: "#c6e2f6",
  ALERT_BUTTON_CLOSE_COLOR: "#ea969d",
  HEADER: "#2a383b",
  BORDER_BACKGROUND: "#d6d6d6",
  CAR_BOX_EVEN: "#DEDFD5",
  CAR_BOX_ODD: "#f5bf19",
  bg: "rgb(36 36 36)",
  bgblue: "#1a468d",
  bgdarkblue: "#2c5596",
};
